import { render, staticRenderFns } from "./MessageClass.vue?vue&type=template&id=b33e7920&"
import script from "./MessageClass.vue?vue&type=script&lang=js&"
export * from "./MessageClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b33e7920')) {
      api.createRecord('b33e7920', component.options)
    } else {
      api.reload('b33e7920', component.options)
    }
    module.hot.accept("./MessageClass.vue?vue&type=template&id=b33e7920&", function () {
      api.rerender('b33e7920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/MessageClass.vue"
export default component.exports